export enum SelectTypeEnum {
    SELECT = "select",
    MULTISELECT = "multiselect",
    YEAR = "year",
    BOOLEAN = "boolean",
    ADVANCED = "advanced"
}